<template>
  <main>
    <div class="filter">
      <button
        @click="filterDialog = !filterDialog"
        class="btn-primary filter__toggle"
      >
        <div class="filter__toggle-icon">
          <svgicon
            :icon="filterDialog ? 'clear' : 'options'"
            :width="filterDialog ? '25px' : '20px'"
          />
        </div>
        <span>Фильтр</span>
        <svgicon icon="arrow" width="15px" />
      </button>

      <VInput
        v-model="search"
        icon="search"
        @enter="searchOrder"
        width="469px"
        placeholder="Поиск по заявкам"
        style="margin-left: -6px"
      />

      <Button
        @click="changeLogDialog = true"
        :loading="historyLoading"
        dark
        text="Журнал изменений"
        icon="sortDown"
        iconWidth="25px"
        class="btn-outline-primary"
        width="250px"
        height="48px"
      />
      <Button
        v-if="isLogist || isOSRStaff || isAdmin || isSuperAdmin"
        @click="$router.push({ name: 'Passengers' })"
        :text="'Справочники'"
        icon="guide"
        iconWidth="20px"
        class="btn-outline-primary"
        width="188px"
        height="48px"
      />
    </div>

    <transition name="fade">
      <div v-show="filterDialog" class="filter__dialog">
        <Form v-model="filter" @request="setFilter" ref="filter">
          <div class="filter__dialog-fields">
            <div class="filter__field--full mb-10">
              <VSwitch
                  v-model="switchValue"
                  label="Не просмотренные"
              />
              <VSwitch v-if="this.isLogist || this.isAdmin" 
                v-model="filter.isControl"
                label="Контроль СВП" />
            </div>
            <div class="filter__date-fields">
              <div class="filter__date-name">По дате создания</div>
              <VInput
                name="created_at"
                type="date"
                placeholder="От"
              />
              <VInput
                name="created_to"
                type="date"
                placeholder="До"
              />
            </div>
            <div class="filter__date-fields">
              <div class="filter__date-name">По дате отправления</div>
              <VInput
                  name="start_at"
                  type="date"
                  placeholder="От"
              />
              <VInput
                  name="start_to"
                  type="date"
                  placeholder="До"
              />
            </div>
            <div class="filter__date-fields">
              <div class="filter__date-name">По дате прибытия</div>
              <VInput
                  name="arrival_at"
                  type="date"
                  placeholder="От"
              />
              <VInput
                  name="arrival_to"
                  type="date"
                  placeholder="До"
              />
            </div>
            <div>
              <VSelect
                  placeholder="№ билета"
                  name="ticket"
                  searchSelect
                  item-text="number_ticket"
                  :items="tickets"
                  tickets
              />
            </div>
            <div>
              <VSelect
                placeholder="Статус заявки"
                name="status"
                multiple
                withCheckbox
                :items="statusOptions"
                status
              >
                <template slot="item" slot-scope="{ item }">
                  <VStatus :status="item" />
                </template>
              </VSelect>
            </div>       
            <div>
              <VSelect
                placeholder="По ФИО руководителя"
                name="supervisor"
                :items="leaders"
                searchSelect
                leader
              >
                <template slot="item" slot-scope="{ item }">
                  <AccountBadge :user="item" />
                </template>
              </VSelect>
            </div>
            <div>
              <VSelect
                placeholder="По ФИО логиста"
                name="logistician"
                :items="logisticians"
                searchSelect
                logist
              >
                <template slot="item" slot-scope="{ item }">
                  <AccountBadge :user="item" />
                </template>
              </VSelect>
            </div>
            <div>
              <VSelect
                placeholder="По ФИО пассажира"
                name="user_passenger"
                :items="usersWithFIO"
                searchSelect
                users
              >
                <template slot="item" slot-scope="{ item }">
                  <AccountBadge :user="item" />
                </template>
              </VSelect>
            </div>
            <div>
              <VSelect
                placeholder="По ФИО пассажира-несотрудника"
                name="external_passenger"
                :items="passengersWithFIO"
                searchSelect
                passengers
              >
                <template slot="item" slot-scope="{ item }">
                  <AccountBadge :user="item" />
                </template>
              </VSelect>
            </div>
            <div>
              <VSelect
                placeholder="ФИО автора заявки"
                name="user"
                :items="usersWithFIO"
                searchSelect
                users
              >
                <template slot="item" slot-scope="{ item }">
                  <AccountBadge :user="item" />
                </template>
              </VSelect>
            </div>
            <div>
              <VSelect
                  placeholder="Подразделение"
                  name="user_department"
                  item-text="name"
                  :items="departments"
                  searchSelect
                  department
              />
            </div>
            <div class="filter__switch">
              <VSwitch
                  v-model="switchNested"
                  label="Включая вложенные"
              />
            </div>
          </div>

          <div class="button__wraper" style="margin-top: 32px">
            <Button
              text="Применить фильтр"
              class="btn-primary"
              width="181px"
              height="40px"
            />
            <Button
              @click.native.prevent="setFilter({}, true)"
              text="Очистить"
              class="btn-secondary"
              width="109px"
              height="40px"
            />
          </div>
        </Form>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="filterTabs.length || getOrdersListSwitch || getOrdersListSwitchNested || isControl" class="tabs">
        Отфильтровано:

        <span
          v-if="getOrdersListSwitch"
          class="tabs__item"
        >
          Не просмотренные
          <svgicon
            @click="deleteSwitch()"
            icon="clear"
            width="18"
            class="tabs__item-icon"
          />
        </span>
        <span
            v-if="getOrdersListSwitchNested"
            class="tabs__item"
        >
          Включая вложенные
          <svgicon
              @click="deleteSwitchNested()"
              icon="clear"
              width="18"
              class="tabs__item-icon"
          />
        </span>
        <span
            v-if="isControl"
            class="tabs__item"
        >
          Контроль СВП
          <svgicon
              @click="deleteControlSwitch()"
              icon="clear"
              width="18"
              class="tabs__item-icon"
          />
        </span>

        <span
          v-show="tab"
          class="tabs__item"
          v-for="(tab, i) in filterTabs"
          :key="i + 'tab'"
        >
          {{ tab }}

          <svgicon
            @click="deleteTab(tab)"
            icon="clear"
            width="18"
            class="tabs__item-icon"
          />
        </span>
        <button
            class="buttons__item"
            @click="setFilter({}, true)"
            style=""
        >
          Сбросить
        </button>
      </div>
    </transition>

    <section class="orders">
      <PageName title="Заявки" :buttons="buttons" />
      <Preloader v-if="ordersLoading" />
      <VTable
        v-show="!ordersLoading"
        itemsType="array"
        :columns="ordersColumns"
        :items="mapedOrders"
        :sortApi="sortOrders"
        :selectedIndices="selectedIndices"
        @select="select"
        @row-click="openOrder"
        selectable
        isOrder
        ref="table"
      />
      <div v-if="!allOrdersLoaded && orders.length" style="text-align: center; margin-top: 20px;">
        <Button
          v-show="!ordersLoading"
          @click="loadMoreOrders"
          :loading="nextPageLoading"
          text="Загрузить еще 100"
          class="btn-primary"
          width="250px"
          height="48px"
        />
      </div>
    </section>

    <Histoty
      v-if="changeLogDialog"
      @close="changeLogDialog = false"
      @loading="historyLoading = !historyLoading"
      ref="history"
    />

    <!-- Добавить callback смены статусов для всех выбранных заявок на "Отправлено в ТК" -->
    <SealModal
      v-if="sealDialog"
      @close="sealDialog = false"
      :callback="() => {}"
      :orderIds="Object.keys(selectedOrdersIds)"
      :propOptions="[
        { name: 'Реестр заявок', id: 2 },
        { name: 'Реестр заявок по дате отправления', id: 3 }
      ]"
      period
    />
  </main>
</template>

<script>
import { simpleDate } from "@/utils/filters/dateFilters";
import { FIO } from "@/utils/filters/stringFilters";
import { getOrders } from "@/api/orders.js";
import { debounce } from "@/utils/utils";
import {mapState, mapGetters, mapActions} from "vuex";
import moment from "moment";
import PageOptions from "@/models/PageOptions";
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Button from "@/components/Button.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import PageName from "@/components/PageName.vue";
import VStatus from "@/components/VStatus.vue";
import SealModal from "@/components/Modals/SealModal.vue";
import Histoty from "@/views/Orders/History.vue";
import VTable from "@/components/Table/VTable.vue";
import FilterController from "@/controllers/FilterController";
import Preloader from "@/components/Preloader";
import VSwitch from "@/components/VSwitch.vue";
import { getUserWithRole } from "@/api/users";
import { getTicketsAll } from "@/api/tickets";
import * as orderStateService from "@/utils/Orders/orderStateService";

export default {
  name: "Orders",
  components: {
    Form,
    VSelect,
    VInput,
    Button,
    AccountBadge,
    PageName,
    VStatus,
    VTable,
    Histoty,
    SealModal,
    Preloader,
    VSwitch
  },
  mounted() {
    const savedState = orderStateService.loadState();

    if (savedState && savedState.pageOptions) {
      // Восстанавливаем состояние
      this.pageOptions = { ...this.pageOptions, ...savedState.pageOptions };
      this.filter = { ...this.filter, ...savedState.filter };
      this.switchValue = savedState.switchValue || false;
      this.switchNested = savedState.switchNested || false;
      
      // Восстанавливаем состояние переключателей в Vuex
      this.$store.dispatch('options/getOrdersListSwitch', this.switchValue);
      this.$store.dispatch('options/getOrdersListSwitchNested', this.switchNested);

      // Восстанавливаем количество загруженных записей
      const loadedItemsCount = savedState.loadedItemsCount || 100;
      
      // Восстанавливаем состояние загрузки всех заявок
      this.allOrdersLoaded = savedState.allOrdersLoaded || false;
      
      // Гарантируем, что per-page корректен
      this.pageOptions['per-page'] = 100; // Стандартный размер страницы для API
      
      // Запрашиваем все ранее загруженные записи одним запросом
      const requestOptions = {
        ...this.pageOptions,
        page: 1, // Всегда начинаем с первой страницы
        'per-page': loadedItemsCount // Запрашиваем нужное количество
      };
      
      // Обновляем внутренние счетчики для корректной работы дозагрузки
      this.pageOptions.page = Math.ceil(loadedItemsCount / 100);
      
      this.getOrders(requestOptions);

    } else {
      // Логика для первого входа, когда нет сохраненного состояния
      if (this.getOrdersSort.flag) this.pageOptions.sort = this.getOrdersSort.value
      else this.pageOptions.sort = '-'+this.getOrdersSort.value
      this.pageOptions['per-page'] = 100;
      this.getOrders(this.pageOptions);
    }
    
    // Восстанавливаем состояние сортировки в Vuex после инициализации
    this.$nextTick(() => {
      const savedState = orderStateService.loadState();
      if (savedState && savedState.pageOptions && savedState.pageOptions.sort) {
        const sortValue = savedState.pageOptions.sort.startsWith('-') 
          ? savedState.pageOptions.sort.substring(1) 
          : savedState.pageOptions.sort;
        const sortFlag = !savedState.pageOptions.sort.startsWith('-');
        const sortIdx = this.ordersColumns.findIndex(col => col.value === sortValue);
        
        if (sortIdx !== -1) {
          this.setSort({ value: sortValue, idx: sortIdx, flag: sortFlag });
        }
      }
    });

    // Инициализация UI-компонентов, не зависящая от данных
    getUserWithRole(3).then(
      (res) => (this.leaders = res.data || null)
    )
    getUserWithRole(5).then(
      (res) => (this.logisticians = res.data || null)
    )
    getTicketsAll().then(
      (res) => (this.tickets = res.data || null)
    )
  },
  data() {
    return {
      filterDialog: false,
      changeLogDialog: false,
      sealDialog: false,

      orders: [],
      search: "",

      ordersLoading: true,
      historyLoading: false,

      pageOptions: new PageOptions(),
      nextPageLoading: false,
      allOrdersLoaded: false,
      debounce: null,

      ordersColumns: [
        { title: "№ Заявки", sort: true, value: "id" },
        { title: " ", sort: false, value: "viewed" },
        { title: "Дата создания", sort: true, value: "created_at" },
        { title: "Статус", sort: true, value: "statuses.name" },
        { title: "Автор заявки", sort: true, value: "users.surname" },
        { title: "Дата отправления", sort: true, value: "start_at" },
        { title: "Откуда", sort: true, value: "point_from" },
        { title: "Куда", sort: true, value: "point_to" },
        { title: "Кол-во пассажиров", sort: true, value: "passenger_count" },
        { title: "Сложность маршрута", sort: true, value: "complexity" },
        { title: "ФИО руководителя", sort: true, value: "supervisor.surname" },
        { title: "ФИО логиста", sort: true, value: "logistician.surname" },
      ],

      selectedOrdersIds: {},
      filter: {
        ...FilterController.options,
        isControl: false
      },
      switchValue: false,
      switchNested: false,
      leaders: [],
      logisticians: [],
      tickets: [],
    };
  },
  computed: {
    ...mapState("options", ["statusOptions"]),
    ...mapState("departments", ["departments"]),
    ...mapGetters("users", ["isLogist", "isAdmin", "isSuperAdmin", "isOSRStaff", "usersWithFIO", "passengersWithFIO"]),
    ...mapGetters('options', ['getOrdersSort', 'getOrdersTab', 'getOrdersListPagination', 'getOrdersListSwitch', 'getOrdersListSwitchNested']),
    mapedOrders() {
      return this.orders?.map((order) => {
        const userFIO = order.user && this.convertName(order.user);
        const logistFIO =
          order.logistician && this.convertName(order.logistician);
        const leadFIO = order.supervisor && this.convertName(order.supervisor);

        return [
          {
            changed: order.changed,
            statusId: order.status?.id,
            parentId: order.parent_id || order.parentId || null,
            osr: { approvable: order.is_osr_approvable, vote: order.osr_vote },
          },
          order.number,
          order.viewed,
          order.created_at ? simpleDate(order.created_at) : "-",
          order.status?.name || "-",
          userFIO || "-",
          order.start_at ? simpleDate(order.start_at) : "-",
          order.point_from || "-",
          order.point_to || "-",
          order.passenger_count || "-",
          order.complexity || "-",
          leadFIO || "-",
          logistFIO || "-",
        ];
      });
    },
    buttons() {
      return [
        {
          text: "Создать заявку",
          icon: "addFile",
          event: () => this.$router.push("/order/create"),
        },
        {
          text: "Печать",
          icon: "printer",
          event: () => this.openSealDialog(),
          hide: !this.isLogist && !this.isAdmin && !this.isSuperAdmin,
        },
      ];
    },
    selectedIndices: {
      get() {
        const indeces = [];

        this.orders.forEach((order, i) => {
          if (this.selectedOrdersIds[order.id] !== undefined) {
            indeces.push(i);
          }
        });

        return indeces;
      },
      set(val) {
        const ids = {};
        for (let index = 0; index < val.length; index++) {
          const order = this.orders[val[index]];
          if (order?.id) ids[order.id] = order;
        }
        this.selectedOrdersIds = ids;
      },
    },
    filterTabs() {
      const excludedKeys = ['isControl']; // Поля, которые отображаются отдельно
      
      return Object.entries(this.filter)
        .filter(([key, value]) => !excludedKeys.includes(key) && this.hasValue(value))
        .flatMap(([, value]) => this.getFilterDisplayValue(value));
    },
    switch () {
      return this.getOrdersListSwitch
    },
    // Геттер для isControl из фильтра
    isControl() {
      return this.filter.isControl || false;
    },
  },
  methods: {
    ...mapActions("options", ["setSort"]),
    ...mapActions("options", ["setTab"]),
    getOrders(params) {
      this.ordersLoading = true;
      // Сбрасываем флаг только при новых запросах (фильтр, сортировка), но не при восстановлении состояния
      // Проверяем, является ли это восстановлением состояния (когда запрашивается больше стандартных 100 записей)
      const isStateRestoration = params['per-page'] > 100;
      if (!isStateRestoration) {
        this.allOrdersLoaded = false;
      }

      getOrders(params)
        .then(res => {
          this.orders = res.data.data;

          // ВАЖНО: Сверяемся с запрошенным количеством, а не с глобальным
          const requestedCount = params['per-page'] || 100;
          if (res.data.data.length < requestedCount) {
            this.allOrdersLoaded = true;
          }

          this.$store.commit('options/SET_ORDERS_LIST_PAGINATION', res.headers);
        })
        .finally(() => (this.ordersLoading = false));
    },
    loadMoreOrders() {
      if (this.nextPageLoading || this.allOrdersLoaded) return;

      this.nextPageLoading = true;
      this.pageOptions.page++;

      getOrders(this.pageOptions)
        .then(res => {
          if (res.data.data.length) {
            this.orders.push(...res.data.data);
          }

          // Сверяемся со стандартным размером страницы
          if (res.data.data.length < this.pageOptions['per-page']) {
            this.allOrdersLoaded = true;
          }
        })
        .finally(() => {
          this.nextPageLoading = false;
        });
    },
    openOrder(num) {
      this.$router.push(`/order/read/${this.orders[num - 1].id}`);
    },
    setFilter(data = {}, clear = false) {
      if (clear) {
        this.$refs.filter.clear()
        this.filter.status = null
        this.switchValue = false
        this.filter.isControl = false
        this.switchNested = false
        orderStateService.clearState(); // Очищаем хранилище
      }

      this.pageOptions = {
        ...this.pageOptions,
        page: 1,
        'per-page': 100, // Явно задаем стандартный размер страницы
        "search[Status]": data.status
            ? data.status.map(({ id }) => id)
            : null,
        "search[CreatedAt]": data.created_at
          ? moment(data.created_at, "DD.MM.YYYY").format("YYYY/MM/DD")
          : null,
        "search[CreatedTo]": data.created_to
          ? moment(data.created_to, "DD.MM.YYYY").format("YYYY/MM/DD")
          : null,
        "search[StartAt]": data.start_at
          ? moment(data.start_at, "DD.MM.YYYY").format("YYYY/MM/DD")
          : null,
        "search[StartTo]": data.start_to
          ? moment(data.start_to, "DD.MM.YYYY").format("YYYY/MM/DD")
          : null,
        "search[ArrivalAt]": data.arrival_at
            ? moment(data.arrival_at, "DD.MM.YYYY").format("YYYY/MM/DD")
            : null,
        "search[ArrivalTo]": data.arrival_to
            ? moment(data.arrival_to, "DD.MM.YYYY").format("YYYY/MM/DD")
            : null,
        "search[UserDepartment]": (!this.switchNested && data.user_department?.id) ? data.user_department?.id : null,
        "search[Supervisor]": data.supervisor?.id || null,
        "search[Logistician]": data.logistician?.id || null,
        "search[UserPassengerId]": data.user_passenger?.id || null,
        "search[ExternalPassengerId]": data.external_passenger?.id || null,
        "search[User]": data.user?.id || null,
        "search[Ticket]": data.ticket?.id || null,
        "search[Viewed]": this.switchValue ? this.switchValue : null,
        "search[IsControl]": this.filter.isControl ? this.filter.isControl : null,
        "search[UserDepartmentNested]": (this.switchNested && data.user_department?.id) ? data.user_department?.id : null,
      };

      this.$store.dispatch('options/getOrdersListSwitch', this.switchValue)
      this.$store.dispatch('options/getOrdersListSwitchNested', this.switchNested)
      this.getOrders(this.pageOptions);
    },
    convertName(user) {
      const { name, surname, patronymic } = user;
      return FIO(name, surname, patronymic);
    },
    sortOrders(col, sort) {
      // 1. Определяем, сколько записей на экране
      const currentItemCount = this.orders.length > 0 ? this.orders.length : 100;

      // 2. Сохраняем параметры сортировки в Vuex
      const idx = this.ordersColumns.findIndex(el => el.value === col.value);
      this.setSort({ value: col.value, idx: idx, flag: sort });

      // 3. Создаем временный объект параметров, наследуя активные фильтры
      const sortPageOptions = {
        ...this.pageOptions,
        page: 1, // Для сортировки всегда запрашиваем с первой страницы
        'per-page': currentItemCount, // Запрашиваем столько же, сколько было на экране
        sort: (sort ? "" : "-") + col?.value, // Добавляем новый параметр сортировки
      };

      // 4. Вызываем getOrders с временными параметрами
      this.getOrders(sortPageOptions);

      // 5. Обновляем основные pageOptions для будущих подгрузок
      this.pageOptions.page = Math.ceil(currentItemCount / 100); // Вычисляем "текущую" страницу
      this.pageOptions.sort = sortPageOptions.sort; // Сохраняем новую сортировку
      
      // Сохраняем обновленное состояние сразу после сортировки
      this.persistState();
    },
    openSealDialog() {
      // if (Object.keys(this.selectedOrdersIds).length) {
        this.sealDialog = true;
      // }isOrder
    },
    select(value, index, all = null) {
      if (all !== null) {
        this.selectedIndices = all ? this.orders.map((el, i) => i) : [];
      } else if (value) {
        this.selectedIndices = [...this.selectedIndices, index];
      } else {
        this.selectedIndices = this.selectedIndices.filter((i) => i === index);
      }
    },
    deleteTab(tabText) {
      for (let key in this.filter) {
        const value = this.filter[key];

        if (Array.isArray(value)) {
          const deleteIndex = value.findIndex(({ name }) =>
            tabText.includes(name)
          );
          deleteIndex != -1 && this.$delete(value, deleteIndex);
        } else if (
          typeof value == "object" &&
          tabText.includes(value?.surname || value?.name)
        ) {
          this.filter[key] = null;
        } else if (tabText.includes(value)) {
          this.filter[key] = null;
        }
      }
      this.setFilter(this.filter);
    },

    deleteSwitch(){
      this.switchValue = false
      this.setFilter(this.filter);
    },

    deleteSwitchNested(){
      this.switchNested = false
      this.setFilter(this.filter);
    },

    deleteControlSwitch(){
      this.filter.isControl = false
      this.setFilter(this.filter);
    },
    
    // Утилитарные методы для filterTabs
    hasValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object' && value !== null) {
        return true;
      }
      return Boolean(value);
    },
    
    getFilterDisplayValue(value) {
      if (Array.isArray(value)) {
        return value.map(({ name }) => name);
      }
      if (typeof value === 'object' && value !== null) {
        if (value.number_ticket) {
          return [value.number_ticket];
        }
        return [FIO(value.name, value.surname, value.patronymic)];
      }
      return [value];
    },

    searchOrder() {
      this.pageOptions = {
        ...this.pageOptions,
        page: 1,
        "search[all]": this.search || null,
      };

      if (!this.debounce) {
        this.debounce = debounce(() => {
          this.getOrders(this.pageOptions);

          this.debounce = null;
        }, 500);

        this.debounce();
      }
    },
    persistState() {
      const stateToSave = {
        pageOptions: {
          sort: this.pageOptions.sort,
          'per-page': this.pageOptions['per-page'] || 100, // Сохраняем per-page
          ...Object.keys(this.pageOptions).reduce((acc, key) => {
            if (key.startsWith('search')) {
              acc[key] = this.pageOptions[key];
            }
            return acc;
          }, {})
        },
        filter: this.filter, // Сохраняем весь объект filter
        switchValue: this.switchValue,
        switchNested: this.switchNested,
        loadedItemsCount: this.orders.length || 100, // Сохраняем количество загруженных записей
        allOrdersLoaded: this.allOrdersLoaded, // Сохраняем состояние загрузки всех заявок
      };
      orderStateService.saveState(stateToSave);
    },
  },
  watch: {
    pageOptions: {
      handler() {
        this.persistState();
      },
      deep: true
    },
    filter: {
      handler() {
        this.persistState();
      },
      deep: true
    },
    switchValue() {
      this.persistState();
    },
    switchNested() {
      this.persistState();
    },
    orders: {
      handler() {
        // Сохраняем состояние при изменении массива orders (включая дозагрузку)
        this.persistState();
      },
      deep: false // Отслеживаем только изменения самого массива
    },
    allOrdersLoaded() {
      // Сохраняем состояние при изменении флага загрузки всех заявок
      this.persistState();
    }
  },
};
</script>

<style scoped lang="scss">
  .buttons__item {
    color: $dark-blue;
    font-size: 16px;

    &:hover {
      color: $blue;
      fill: $blue;
    }
  }
  .filter {
    display: flex;
    position: relative;
    column-gap: 12px;

    .filter__toggle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 20px;
      width: 176px;
      height: 48px;

      .filter__toggle-icon {
        min-width: 25px;
        max-width: 25px;
      }
    }

    &__date {
      &-fields {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 12px;
        row-gap: 12px;
        position: relative;
      }

      &-name {
        font-weight: 400;
        font-size: 14px;
        line-height: 25px;
        position: absolute;
        top: -25px;
      }
    }

    &__switch {
      display: flex;
      align-items: end;
    }
    &__field {
      &--full {
        display: flex;
        gap: 12px;
        grid-column: 1 / -1;
      }
    }
  }
  .filter__dialog {
    background: white;
    margin-top: 12px;
    padding: 55px 30px 30px 20px;
    box-shadow: 0px 8px 8px rgba(0, 32, 51, 0.04),
      0px 12px 28px rgba(0, 32, 51, 0.12);
    border-radius: 4px;
    max-width: 1193px;
    z-index: 100;

    .filter__dialog-fields {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 12px;
      row-gap: 30px;
    }

    button {
      font-size: 16px;
    }
  }
  .orders {
    margin-top: 32px;
  }
  .tabs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 19px;
    color: $dark-gray;
    fill: $dark-gray;
    column-gap: 8px;
    row-gap: 8px;

    .tabs__item {
      display: flex;
      align-items: center;
      background: $light-gray;
      height: 30px;
      border-radius: 4px;
      padding: 0 12px;

      svg {
        margin-left: 8px;
        cursor: pointer;
        transition: 0.2s;

        &:hover {
          fill: $red;
        }
      }
    }
  }
</style>
